import axios from 'axios'
import { useUserStore } from '@/stores/club_admin/UserStore'
import router from "@/routes/navigation"

const getSubdomain = () => {
  const hostParts = window.location.hostname.split('.')
  return hostParts[0] || 'default'
}

const BASE_URL = `${process.env.VUE_APP_API_PROTOCOL}://${getSubdomain()}${process.env.VUE_APP_API_SUFFIX}`

const apiClient = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem('token')}`
  },
})

apiClient.interceptors.request.use(config => {
  const userStore = useUserStore()
  const token = userStore.token

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  } else {
    router.push('/')
  }

  return config
}, error => {
  return Promise.reject(error)
})

export default apiClient
